import React from 'react';
import configureStore from './store/configureStore';
import { Provider } from 'react-redux';
import { successSocialAuth } from 'actions/user'
import { fetchUserAPI } from 'async/login'
const store = configureStore();
import HomePage from 'components/home/HomePage';



window.fbAsyncInit = function () {
  // eslint-disable-next-line
  FB.init({
            appId: '1207136229334300',
            xfbml: true,
            version: 'v2.8'
          });
};

(function (d, s, id) {
  let js, fjs = d.getElementsByTagName(s)[ 0 ];
  if (d.getElementById(id)) {
    return;
  }
  js = d.createElement(s);
  js.id = id;
  js.src = "//connect.facebook.net/en_US/sdk.js";
  fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));

const App = () => {

  if (window.localStorage.getItem('logged_in') === 'true') {
    const user = JSON.parse(window.localStorage.getItem('user_social'));
    store.dispatch(successSocialAuth(user))

    fetchUserAPI(user, store.dispatch);

  }
  return (
      <Provider store={ store }>
        <HomePage />

      </Provider>
  )
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js